
const AddCompanyReducer = (state = {display: false, 
                                    displayeditcompany:false,
                                    displayeditcompanyavm:false}, action) => {
    switch (action.type) {
        case 'ToggleAddCompany':
            return {display: !state.display};
        case 'ShowAddCompany':
            return {display: true};
        case 'HideAddCompany':
            return {display: false};

        case 'EditCompanyAddress' :
            return {displayeditcompany: true};
        case 'HideEditCompanyAddress' :
            console.log("HideEditCompanyAddress");
            return {displayeditcompany: false};

        case 'ShowEditCompanyAVM' :
            return {displayeditcompanyavm: true};
        case 'HideEditCompanyAVM' :
            return {displayeditcompanyavm: false};

        default: return state;
    };
}
export default AddCompanyReducer;